const filterRegionSpecificPrices = {
  US: {
    air: {
      base: 123399,
      del: null,
    },
    airMini: {
      base: 219,
      del: null,
    },
    milaFilter: {
      base: 12369,
      del: null,
    },
    milaSocks: {
      base: 12360,
      del: null,
    },
  },
  CA: {
    air: {
      base: 123489,
      del: null,
    },
    airMini: {
      base: 279,
      del: null,
    },
    milaFilter: {
      base: 12380,
      del: null,
    },
    milaSocks: {
      base: 12365,
      del: null,
    },
  },
  GB: {
    air: {
      base: 123349,
      del: null,
    },
    airMini: {
      base: 123199,
      del: 268,
    },
    milaFilter: {
      base: 12349,
      del: null,
    },
    milaSocks: {
      base: 12345,
      del: null,
    },
  },
  AU: {
    air: {
      base: 123599,
      del: null,
    },
    airMini: {
      base: 123199,
      del: 268,
    },
    milaFilter: {
      base: 12399,
      del: null,
    },
    milaSocks: {
      base: 12389,
      del: null,
    },
  },
};

export default filterRegionSpecificPrices;
